/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GiornoDellaSettimanaEnum } from './giorno-della-settimana-enum';


export interface ServizioMensaCalendarioMensaDTO { 
    data_inizio?: string;
    data_fine?: string;
    chiusure_settimanali?: Array<GiornoDellaSettimanaEnum>;
    chiusure_puntuali?: Array<string>;
}

